// extracted by mini-css-extract-plugin
export default {"checkIcon":"aQPVgzOW8Fnljp3lA1OX","collaboratorRolePills":"oIpEMQWnaNjcNgjbBJMx"};